let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("h2810")]).then(() => parcelRequire('ctZ6E'));